import { toPng, toSvg } from "html-to-image";
import Vue from "vue";

interface ExportOptions {
  filename: string;
  props?: Record<string, any>;
  imageType?: "png" | "svg";
  waitMs?: number;
}

export async function exportVueComponentAsImage(Component: typeof Vue, { filename, props = {}, imageType = "png", waitMs = 100 }: ExportOptions, context: { i18n?: any } = {}): Promise<void> {
  const instance = new Vue({
    i18n: context.i18n,
    render: (h) => h(Component, { props: { ...props, exporting: true } }),
  });

  const vm = instance.$mount();
  document.body.appendChild(vm.$el);
  await Vue.nextTick();
  await new Promise((resolve) => setTimeout(resolve, waitMs));

  try {
    await new Promise((resolve) => setTimeout(resolve, waitMs));
    const el = vm.$el as HTMLElement;
    const dataUrl = imageType === "svg" ? await toSvg(el) : await toPng(el);

    const link = document.createElement("a");
    link.download = filename;
    link.href = dataUrl;
    link.click();
  } catch (err) {
    console.error("Export failed:", err);
  } finally {
    instance.$destroy();
    if (vm.$el && vm.$el.parentNode) {
      vm.$el.parentNode.removeChild(vm.$el);
    }
  }
}
